<template>
  <v-card v-show="shop !== 0" class="dash-card">
    <shop-users ref="shopUsersRef" :shopID="shop" style="display:none"></shop-users>
    <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
      <v-toolbar-title>
        {{ getString("Prenotazioni per dipendente") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-side-icon @click="hidden = !hidden">
        <v-icon class="q-text-whitesmoke" :class="{ 'module-closed': !hidden }"
          >arrow_drop_down</v-icon
        >
      </v-toolbar-side-icon>
    </v-toolbar>
    <v-layout row wrap v-show="!hidden">
      <v-flex xs12 sm12 md3 lg3>
        <v-card>
          <v-toolbar
            class="q-orange-bk q-text-whitesmoke elevation-0 no-cradius"
            height="50px"
          >
            <v-toolbar-title>{{ getString("Dipendenti") }}</v-toolbar-title>
          </v-toolbar>
          <v-list two-line>
            <v-progress-circular
              class="full-width q-orange"
              indeterminate
              v-show="EmployeeCard.empLoading"
            ></v-progress-circular>
            <template v-for="(item, index) in EmployeeCard.resStats.employees">
              <v-subheader v-if="item.header" :key="item.header">
                {{ item.header }}
              </v-subheader>

              <v-divider
                v-else-if="item.divider"
                :inset="item.inset"
                :key="index"
              ></v-divider>

              <v-list-tile
                v-else
                :key="item.idEmp"
                avatar
                @click="EmployeeCard.selectedEmp = item.idEmp"
              >
                <v-list-tile-avatar>
                  <img :src="item.photo" />
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="item.employeeName"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ getString("Prenotazioni: ") }}
                    <b> {{ item.count }}</b></v-list-tile-sub-title
                  >
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
        <v-card-text v-show="EmployeeCard.resStats.employees.length <= 0">{{
          getString("Nessun dipendente disponibile nel periodo scelto")
        }}</v-card-text>
      </v-flex>
      <v-flex xs12 sm12 md9 lg9>
        <v-card>
          <v-toolbar
            class="q-whitesmoke-bk q-text-whitesmoke elevation-0 no-cradius"
            height="50px"
          >
            <v-layout row style="margin-top: 25px">
              <v-flex xs5>
                <v-menu
                  ref="dp1"
                  :close-on-content-click="false"
                  v-model="EmployeeCard.dp1"
                  :nudge-right="40"
                  :return-value.sync="EmployeeCard.empDateStart"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="EmployeeCard.empDateStart"
                    :label="getString('Da')"
                    prepend-icon="event"
                    readonly
                    color="red lighten-2"
                  ></v-text-field>
                  <v-date-picker
                    :locale="locale"
                    :title-date-format="formatTitle"
                    show-current
                    color="red lighten-2"
                    v-model="EmployeeCard.empDateStart"
                    @input="$refs.dp1.save(EmployeeCard.empDateStart)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs5>
                <v-menu
                  ref="dp2"
                  :close-on-content-click="false"
                  v-model="EmployeeCard.dp2"
                  :nudge-right="40"
                  :return-value.sync="EmployeeCard.empDateEnd"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="EmployeeCard.empDateEnd"
                    :label="getString('A')"
                    prepend-icon="event"
                    readonly
                    color="red lighten-2"
                  ></v-text-field>
                  <v-date-picker
                    :locale="locale"
                    :title-date-format="formatTitle"
                    show-current
                    color="red lighten-2"
                    v-model="EmployeeCard.empDateEnd"
                    @input="$refs.dp2.save(EmployeeCard.empDateEnd)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="EmployeeCard.search"
              append-icon="search"
              :label="getString('Filtra')"
              single-line
              hide-details
            ></v-text-field>
            <v-tooltip bottom>
              <v-flex slot="activator">
                <v-btn
                  @click="getEmployeesStats"
                  color="red lighten-2"
                  class="no-cradius elevation-0 q-text-whitesmoke"
                >
                  <v-icon>refresh</v-icon>
                </v-btn>
              </v-flex>
              <span>{{ getString("Aggiorna i dati") }}</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <h2 class="q-orange">{{ currentEmp.employeeName }}</h2>
            <v-data-table
              :headers="EmpHeaders"
              :items="selectedEmpItems"
              :search="EmployeeCard.search"
              :rows-per-page-items="[
                10,
                25,
                { text: getString('Tutto'), value: -1 },
              ]"
              :rows-per-page-text="getString('Prenotazioni per pagina')"
              :no-data-text="getString('Dati non disponibili')"
              :loading="EmployeeCard.empLoading"
              class="elevation-0"
            >
              <template slot="items" slot-scope="props">
                <tr :style="props.item.referenceUsers > 0 ? 'cursor:pointer' : ''" @click="props.item.referenceUsers > 0 && openClientCard(props.item)">
                  <!-- <td class="text-xs-left">***</td> -->
                  <!-- <td>
                                <v-list-tile-avatar>
                                    <img :src="defaultAvatar(props.item.photo)">
                                </v-list-tile-avatar>
                            </td> -->
                  <td class="text-xs-left">
                    {{ props.item.uName }} {{ props.item.uSurname }}
                  </td>
                  <td class="text-xs-left">
                    {{ getFormattedDate(props.item.dateAndTime) }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.dateEnd.split("T")[1] }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.service.split(",").join(", ") }}
                  </td>
                  <td class="text-xs-left">
                    {{ eur(props.item.servicesPrice) }}
                  </td>
                  <td class="text-xs-left">
                    {{
                      props.item.referenceUsers === 0
                        ? getString("Pannello")
                        : "App"
                    }}
                  </td>
                </tr>
              </template> 
            </v-data-table>
            <span>Entrate stimate: {{eur(entrateStimate)}}</span>
            <div><i><small>Il valore è calcolato in base ai prezzi registrati e viene mostrato a fini d'esempio e non deve essere considerato un valore fiscale.</small> </i></div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import ajax from "../../../ajax";
import Utils from "../../../utils";
import Moment from "moment";
import ShopUsers from "./ShopUsers";

let ut = new Utils();
export default {
  name: "StatsEmpCard",
  components: { ShopUsers },
  mounted: function () {
    let self = this;
    this.interval = ut.GetCountdown(
      self.$store.getters.tokenObject.Created,
      (s) => {
        self.stuff =
          s.d +
          " " +
          self.getString("giorni e ") +
          ut.NumberWith0(s.h) +
          ":" +
          ut.NumberWith0(s.m) +
          ":" +
          ut.NumberWith0(s.s);
      }
    );
  },
  destroyed: function () {
    ut.ClearCountdown(this.interval);
  },
  computed: {
    entrateStimate: function() {
      return this.selectedEmpItems.reduce((partialSum, item) => partialSum + item.servicesPrice, 0);
    },
    locale: function () {
      return this.$store.state.currentTranslator.locale;
    },
    dyncamicAlertTime: function () {
      return this.alertText.length * 100 > 3000
        ? this.alertText.length * 100
        : 3000;
    },
    isFullscreen: function () {
      return this.$store.state.isFullscreen;
    },
    isAdmin: function () {
      return this.$store.getters.isAdmin;
    },
    selectedEmpItems: function () {
      let result = [];
      let self = this;
      if (Object.keys(this.EmployeeCard.resStats).length > 0) {
        this.EmployeeCard.resStats.reservations.forEach((element) => {
          if (element[0].referenceEmployee === self.EmployeeCard.selectedEmp) {
            result = element;
          }
        });
      }
      return result;
    },
    currentEmp: function () {
      let result = {};
      let self = this;
      if (Object.keys(this.EmployeeCard.resStats).length > 0) {
        this.EmployeeCard.resStats.employees.forEach((element) => {
          if (element.idEmp === self.EmployeeCard.selectedEmp) {
            result = element;
          }
        });
      }
      return result;
    },
    EmpHeaders: function () {
      let result = [];
      let self = this;
      if (Object.keys(this.EmployeeCard.resStats).length > 0) {
        let temp = [
          // self.getString('Id:idReservation'),
          // self.getString('Foto:'),
          self.getString("Nome Cliente:uName"),
          self.getString("Data e ora:dateAndTime"),
          self.getString("Previsione fine:dateEnd"),
          self.getString("Servizio:service"),
          self.getString("Prezzo:servicesPrice"),
          self.getString("Prenotazione da:referenceUsers"),
        ];
        temp.forEach((element) => {
          result.push({
            text: self.getString(element.split(":")[0]),
            align: "left",
            sortable: true,
            value: element.split(":")[1],
          });
        });
        return result;
      }
      return [];
    },
  },
  data: () => {
    return {
      h: null,
      EmployeeCard: {
        resStats: {
          employees: [],
          reservations: [],
          services: [],
        },
        selectedEmp: 0,
        empDateStart:
          new Date().getFullYear() +
          "-" +
          ut.NumberWith0(new Date().getMonth() + 1) +
          "-" +
          ut.NumberWith0(1),
        empDateEnd:
          new Date().getFullYear() +
          "-" +
          ut.NumberWith0(new Date().getMonth() + 1) +
          "-" +
          ut.NumberWith0(new Date().getDate()),
        dp1: false,
        dp2: false,
        empLoading: false,
        search: "",
      },
      hidden: true,
      shop: 0,
    };
  },
  methods: {
    getServicePrice: function (services) {
      let price = 0;
      for (const s of services) {
        const found = this.EmployeeCard.resStats.services.find(
          (x) => x.description === s
        );
        if (found) {
          const p = parseInt(found.price);
          if (!isNaN(p)) {
            price += p;
          }
        }
      }
      return price;
    },
    eur(v) {
      if (v)
        return v.toLocaleString("it-IT", {
          style: "currency",
          currency: "EUR",
        });
      return "";
    },

    getFormattedDate: function (date) {
      return new Moment(date).format("DD/MM/YYYY HH:mm");
    },
    defaultAvatar: function (url) {
      if (
        url === null ||
        url === "images/u_placeholder.jpg" ||
        url === "/images/u_placeholder.jpg"
      ) {
        return "/../../../../static/img/default-avatar.png";
      } else return ajax.baseUrl() + url;
    },
    formatTitle: function (d) {
      var options = {
        weekday: "long",
      };
      return ut.Capitalize(new Date().toLocaleString(this.locale, options));
    },
    setVisibility: function (vis) {
      this.hidden = vis;
    },
    formatDate: function (date) {
      // return (
      //   date.getFullYear() +
      //   '-' +
      //   ut.NumberWith0(date.getMonth() + 1) +
      //   '-' +
      //   ut.NumberWith0(date.getDate())
      // )
      return date;
    },
    getEmployeesStats: function () {
      let self = this;
      this.EmployeeCard.empLoading = true;
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/dashboard/trends/shop/" +
            self.shop +
            "/start/" +
            self.formatDate(self.EmployeeCard.empDateStart, true) +
            "/end/" +
            self.formatDate(self.EmployeeCard.empDateEnd, true),
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.EmployeeCard.resStats = response.data.data;
          if (Object.keys(self.EmployeeCard.resStats).length > 0) {
            if (self.EmployeeCard.resStats.employees[0] !== undefined) {
              self.EmployeeCard.selectedEmp =
                self.EmployeeCard.resStats.employees[0].idEmp;
              self.EmployeeCard.resStats.employees.forEach((element) => {
                element.photo = self.defaultAvatar(element.photo);
              });
            }
            // Ensure servicesPrice is set for all reservations for proper sorting
            if (self.EmployeeCard.resStats.reservations) {
              self.EmployeeCard.resStats.reservations.forEach(empRes => {
                empRes.forEach(res => {
                  if (!res.servicesPrice) {
                    res.servicesPrice = self.getServicePrice(res.service.split(","));
                  }
                });
              });
            }
          }
          self.EmployeeCard.empLoading = false;
        })
        .catch(function (error) {
          self.EmployeeCard.empLoading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          // EMIT ERROR
        });
    },
    init: function (shop) {
      this.shop = shop;
      if (this.shop !== 0) {
        this.getEmployeesStats();
      }
    },
    openClientCard: function (item) {
      this.$refs.shopUsersRef.openDetails({ idUser: item.referenceUsers });
    },
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/backend/pieces/StatsEmpCard.vue